import { useQuery } from '@tanstack/react-query';
import { goodsService } from 'shared/src/api';
import { queryKey } from '../constant/queryKey';
import { useGoodsSno } from '../hooks/useGoodsSno';

/**
 * 상품 문의 탭의 "주문한 상품" 목록. 비로그인/주문 없음이면 `order_items` 가 빈 배열이다.
 * (웹뷰는 suspense 로 받지만, 문의 탭은 탭 전환 시 지연을 만들지 않도록 비suspense 로 둔다)
 */
export const useGoodsContacts = () => {
  const goodsSno = useGoodsSno();

  return useQuery({
    queryKey: queryKey.goodsContacts(goodsSno),
    queryFn: () => goodsService.getGoodsContacts(goodsSno),
  });
};
